<template>
  <el-dialog :visible.sync="dialogVisible" width="480px" :show-close="false" custom-class="profile-dialog"
    :modal-append-to-body="false" class="profile-dialog-mask">
    <div class="dialog-header">
      <h2 class="dialog-title">个人信息</h2>
      <i class="el-icon-close close-icon" @click="dialogVisible = false"></i>
    </div>

    <div class="dialog-body">
      <!-- 用户信息展示 -->
      <div class="user-info-section">
        <!-- 头像 - hover显示编辑遮罩 -->
        <div class="avatar-wrapper">
          <img v-if="userInfoData.avatar" :src="userInfoData.avatar" class="avatar-img" />
          <img v-else src="@/assets/logo.png" class="avatar-img" />
          <div class="avatar-overlay" @click.stop="handleAvatarChange">
            <i class="el-icon-edit"></i>
          </div>

        </div>

        <!-- 昵称编辑 -->
        <div class="nickname-row">
          <template v-if="isEditingNickname">
            <el-input ref="nicknameInput" v-model="nicknameValue" size="small" class="nickname-input" maxlength="20"
              @keyup.enter.native="confirmNickname" @keyup.esc.native="cancelNickname"></el-input>
            <i class="el-icon-check action-icon confirm-icon" @click="confirmNickname"></i>
            <i class="el-icon-close action-icon cancel-icon" @click="cancelNickname"></i>
          </template>
          <template v-else>
            <span class="nickname-text">{{ userInfoData.nickname || '未设置昵称' }}</span>
            <i class="el-icon-edit action-icon edit-icon" @click="startEditNickname"></i>
          </template>
        </div>
      </div>

      <!-- 修改密码区域 -->
      <div class="password-section">
        <div class="section-title">修改密码</div>
        <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="0">
          <el-form-item prop="oldPassword">
            <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" prefix-icon="el-icon-lock"
              show-password></el-input>
          </el-form-item>
          <el-form-item prop="newPassword">
            <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码(至少6位)"
              prefix-icon="el-icon-key" show-password></el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"
              prefix-icon="el-icon-key" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit-btn" :loading="submitting" @click="handleChangePassword">
              确认修改
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { EventBus,EVENTS } from '@/utils/eventBus'
import { userInfo,useredit } from '@/api'
import { uploadImage,uploadImages } from "@/utils/uploadImage";
export default {
  name: 'ProfileDialog',
  data() {
    const validateConfirm = (rule,value,callback) => {
      if(value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      submitting: false,
      userInfoData: {},
      isEditingNickname: false,
      nicknameValue: '',
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true,message: '请输入原密码',trigger: 'blur' }
        ],
        newPassword: [
          { required: true,message: '请输入新密码',trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true,message: '请再次输入新密码',trigger: 'blur' },
          { validator: validateConfirm,trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    EventBus.$on(EVENTS.SHOW_PROFILE_DIALOG,this.showDialog)
  },
  beforeDestroy() {
    EventBus.$off(EVENTS.SHOW_PROFILE_DIALOG,this.showDialog)
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      this.isEditingNickname = false
      this.resetForm()
      this.getUserInfo()
    },
    resetForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.$nextTick(() => {
        if(this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate()
        }
      })
    },
    getUserInfo() {
      const userId = localStorage.getItem('userId')
      if(!userId) return
      userInfo({ userId }).then(res => {
        if(res.code == 200) {
          this.userInfoData = res.data
        }
      })
    },


    async handleAvatarChange() {
      const imagePath = await uploadImage({});
      this.updateUserInfo({ avatar: imagePath })

    },

    // 昵称相关
    startEditNickname() {
      this.nicknameValue = this.userInfoData.nickname || ''
      this.isEditingNickname = true
      this.$nextTick(() => {
        if(this.$refs.nicknameInput) {
          this.$refs.nicknameInput.focus()
        }
      })
    },
    confirmNickname() {
      const name = this.nicknameValue.trim()
      if(!name) {
        this.$message.warning('昵称不能为空')
        return
      }
      if(name === this.userInfoData.nickname) {
        this.isEditingNickname = false
        return
      }
      this.updateUserInfo({ nickname: name })
    },
    cancelNickname() {
      this.isEditingNickname = false
    },

    updateUserInfo(data) {
      useredit({
        id: localStorage.getItem('userId'),
        ...data
      }).then(res => {
        if(res.code == 200) {
          this.$message.success('修改成功')
          this.isEditingNickname = false
          this.getUserInfo()
        } else {
          this.$message.error(res.msg || '修改失败')
        }
      }).catch(() => {
        this.$message.error('修改失败，请重试')
      })
    },

    // 密码相关
    handleChangePassword() {
      this.$refs.passwordForm.validate(valid => {
        if(!valid) return
        if(this.passwordForm.oldPassword != this.userInfoData.password) return this.$message.error('原密码输入不正确')
        this.submitting = true
        useredit({
          id: localStorage.getItem('userId'),
          password: this.passwordForm.newPassword
        }).then(res => {
          if(res.code == 200) {
            this.$message.success('密码修改成功')
            this.resetForm()
            this.getUserInfo()
          } else {
            this.$message.error(res.msg || '密码修改失败')
          }
        }).catch(() => {
          this.$message.error('密码修改失败，请重试')
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style lang="scss">
.profile-dialog-mask {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
</style>

<style lang="scss" scoped>
::v-deep .profile-dialog {
  background-color: #1a1a1a;
  border-radius: 12px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #2d2d2d;

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
  }

  .close-icon {
    font-size: 24px;
    color: #888;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #fff;
    }
  }
}

.dialog-body {
  padding: 32px 28px;
}

.user-info-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;

  .avatar-wrapper {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 20px;
    position: relative;
    cursor: pointer;

    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .avatar-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.25s;

      i {
        font-size: 22px;
        color: #fff;
      }
    }

    &:hover .avatar-overlay {
      opacity: 1;
    }

    .avatar-file-input {
      display: none;
    }
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #8bff8b 0%, #6ee06e 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 36px;
      color: #1a1a1a;
    }
  }

  .nickname-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;

    .nickname-text {
      font-size: 16px;
      color: #fff;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .nickname-input {
      width: 180px;

      ::v-deep .el-input__inner {
        background-color: #2d2d2d;
        border-color: #3d3d3d;
        color: #fff;
        text-align: center;
        height: 36px;
        line-height: 36px;

        &:focus {
          border-color: #8bff8b;
        }
      }
    }

    .action-icon {
      font-size: 16px;
      cursor: pointer;
      transition: color 0.2s, transform 0.2s;
      padding: 4px;

      &:hover {
        transform: scale(1.2);
      }
    }

    .edit-icon {
      color: #888;

      &:hover {
        color: #8bff8b;
      }
    }

    .confirm-icon {
      color: #8bff8b;

      &:hover {
        color: #a5ffa5;
      }
    }

    .cancel-icon {
      color: #888;

      &:hover {
        color: #ff6b6b;
      }
    }
  }
}

.password-section {
  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #2d2d2d;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }

  ::v-deep .el-input__inner {
    background-color: #2d2d2d;
    border-color: #3d3d3d;
    color: #fff;
    height: 42px;

    &::placeholder {
      color: #666;
    }

    &:focus {
      border-color: #8bff8b;
    }
  }

  ::v-deep .el-input__prefix {
    color: #888;
  }

  ::v-deep .el-input__suffix {
    color: #888;
  }

  .submit-btn {
    width: 100%;
    height: 42px;
    background: linear-gradient(135deg, #8bff8b 0%, #6ee06e 100%);
    border: none;
    color: #1a1a1a;
    font-size: 15px;
    font-weight: 500;
    border-radius: 6px;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
